import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const getCards = async (): Promise<cardApiSpec.Card[]> => {
  const { data } = await cardsService.get("");

  return data;
};
